import { CUSTOMER_JOURNEY_ATTRACTIONS_ERROR } from './../const';

function action() {
  return { type: CUSTOMER_JOURNEY_ATTRACTIONS_ERROR };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyAttractionsError.js